import { TeaserCardProps, TeaserCard as TeaserComponent } from '@almbrand/teasercard';
import styles from './TeaserCardComponent.module.scss';

interface TeaserCardComponentProps extends Omit<TeaserCardProps, 'backgroundColor'> {
	backgroundColor?: {
		cssClass?: string;
	};
}
export const TeaserCardComponent: React.FC<TeaserCardComponentProps> = ({ backgroundColor, ...props }) => {
	return (
		<TeaserComponent
			backgroundColor={backgroundColor?.cssClass}
			className={styles.TeaserCardComponent}
			{...props}
		/>
	);
};
